export enum MessageBusListenTypeEum {
  addComponent = 'addComponent',
  changeComponent = 'changeComponent',
  addComponentByIndex = 'addComponentByIndex',
  replaceComponentByIndex = 'replaceComponentByIndex',
  moveComponent = 'moveComponent',
  copyComponent = 'copyComponent',
  deleteComponent = 'deleteComponent',
  changeGlobalConfig = 'changeGlobalConfig',
  replaceComponentList = 'replaceComponentList',
  getEditConfig = 'getEditConfig',
  getCouponList = 'getCouponList',
  saveCouponActivity = 'saveCouponActivity',
  poizonARowGoodsGetList = 'poizon-a-row-goods-get-list'
}

export enum MessageBusSendTypeEum {
  layOutInfo = 'layOutInfo',
  changeActiveIndex = 'changeActiveIndex',
  '$SYSTEM_OK' = '$SYSTEM_OK',
  sendCouponList = 'sendCouponList',
  saveCouponActivityRes = 'saveCouponActivityRes',
  poizonARowGoodsSetList = 'poizon-a-row-goods-set-list'
}
